import React from 'react'

const QuoteHeader = () => {
  return (
    <div className='quotehead'>
        {/* <div className='title'>VALUE  ADDED COATING SOLUTION PVT. LTD</div> */}
        <div className='title'>Value Added Coating Solution Pvt Ltd</div>
        <div className='address'><strong>Head Office :</strong> 515, Devika Tower, Chandra Nagar, Ghaziabad, U.P.</div>
        <div className='address'><strong>Manufacturing Plant :</strong> K-288, Site-V, Kasna Industrial Area, Noida (U.P.)</div>
        <div className='address'><strong>Website :</strong> www.coating-solution.com, www.optifinish.in</div>
        <div className='address'><strong>Contact :</strong> +91- 9811846214, +91- 9811357749 info@coating-solution.com,</div>
    </div>
  )
}

export default QuoteHeader